// extracted by mini-css-extract-plugin
module.exports = {"touCont":"TermsOfUse_touCont__pNTQp","pageContent":"TermsOfUse_pageContent__1qJXf","titleContainer":"TermsOfUse_titleContainer__1DMXj"};